import { useState } from "react";
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next';

function Contact() {
    const { t } = useTranslation();
    const [copy, setCopy] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const [form, setForm] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [error, setError] = useState('');
    const email = "aliameurpro@gmail.com";

    const copyToClipboard = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(email).then(() => {
                setCopy(true);
                setTimeout(() => {
                    setCopy(false);
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = email;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setCopy(true);
                setTimeout(() => {
                    setCopy(false);
                }, 2000);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
            document.body.removeChild(textArea);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (form.email === "" || form.name === "" || form.message === "") {
            return setError(t('contact.error.requiredFields'));
        }

        setIsLoading(true);

        emailjs.send('service_cpj1dtv', 'template_2vupova', form, 'uhFkIjqgX9uLd9JHn')
            .then(() => {
                setError('');
                setShowAlert(true);
                setForm({ name: '', email: '', message: '' });

                setTimeout(() => {
                    setShowAlert(false);
                }, 8000);
            })
            .catch((error) => {
                console.error('Error sending email:', error);
                setError(t('contact.alert.error'));
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="relative overflow-hidden py-20 md:py-40">
            {/* blurred background elements */}
            <div className="absolute -top-20 -left-20 w-64 h-64 bg-primary/20 dark:bg-primary/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob"></div>
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-secondary/20 dark:bg-secondary/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob animation-delay-2000"></div>
            <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-accent/20 dark:bg-accent/40 rounded-full filter blur-3xl opacity-70 dark:opacity-30 animate-blob animation-delay-4000"></div>
            <div className="container mx-auto px-4">
                <div className='flex flex-col lg:flex-row justify-center lg:justify-evenly items-center relative z-10'>
                    <div className='pb-16 pt-8 md:pt-12 bg-base-100 rounded-3xl mx-4 md:mx-0 px-4 w-full md:px-12 md:w-10/12 lg:w-1/3'>
                        <div className='text-xl md:text-2xl lg:text-3xl font-extrabold mb-3 text-primary'>
                            {t('contact.title')}
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className='space-y-3 mt-4 w-full'>
                                <label className="form-control">
                                    <div className="label">
                                        <span className="label-text font-semibold">
                                            {t('contact.form.name')} <span className='text-error'>*</span>
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder={t('contact.form.namePlaceholder')}
                                        className={`input input-bordered w-full focus:input-primary ${error && !form.name && 'input-error ring-1 ring-error'}`}
                                        value={form.name}
                                        onChange={(e) => { setForm({ ...form, name: e.target.value }); setError(''); }}
                                    />
                                </label>
                                <label className="form-control">
                                    <div className="label">
                                        <span className="label-text font-semibold">
                                            {t('contact.form.email')} <span className='text-error'>*</span>
                                        </span>
                                    </div>
                                    <input
                                        type="email"
                                        placeholder={t('contact.form.emailPlaceholder')}
                                        className={`input input-bordered w-full focus:input-primary ${error && !form.email && 'input-error ring-1 ring-error'}`}
                                        value={form.email}
                                        onChange={(e) => { setForm({ ...form, email: e.target.value }); setError(''); }}
                                    />
                                </label>
                                <label className="form-control">
                                    <div className="label">
                                        <span className="label-text font-semibold">
                                            {t('contact.form.message')} <span className='text-error'>*</span>
                                        </span>
                                    </div>
                                    <textarea
                                        className={`textarea textarea-bordered h-32 focus:textarea-primary ${error && !form.message && 'textarea-error ring-1 ring-error'}`}
                                        placeholder={t('contact.form.messagePlaceholder')}
                                        value={form.message}
                                        onChange={(e) => { setForm({ ...form, message: e.target.value }); setError(''); }}
                                    />
                                </label>
                            </div>

                            {error && (
                                <div>
                                    <div className="flex items-center absolute">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            className="size-6 text-error mx-1 my-2"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                        <div className="text-error text-sm font-semibold mx-1 my-2">
                                            {error}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className='flex mt-10 gap-x-3'>
                                <button className='btn btn-secondary px-6' type='submit' disabled={isLoading}>
                                    {isLoading ? t('contact.form.sending') : t('contact.form.sendMessage')}
                                </button>
                                {!copy
                                    ?
                                    <div className='btn btn-outline hover:space-x-1' onClick={copyToClipboard}>
                                        <span>{t('contact.form.copyEmail')}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                                        </svg>
                                    </div>
                                    :
                                    <div className='btn no-animation'>
                                        <span>{t('contact.form.copied')}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
                                        </svg>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>

                    {/* Mockup code - now visible on all screens but stacked on mobile */}
                    <div className='mt-8 lg:mt-0 w-full px-4 md:w-10/12 lg:w-1/3 lg:px-0'>
                        <div className="mockup-code w-full">
                            <br />
                            <pre data-prefix="$" className="text-lg"><code>{t('contact.code.line1')}</code></pre>
                            <br />
                            <pre data-prefix=">" className="text-warning text-lg"><code>{t('contact.code.line2')}</code></pre>
                            <br />
                            <pre data-prefix="" className="bg-warning py-3 text-warning-content text-xl font-bold"><code>{t('contact.code.line3')}</code></pre>
                            <br />
                            <pre data-prefix=">" className="text-success text-lg"><code>{t('contact.code.line4')}</code></pre>
                            <br />
                        </div>
                    </div>
                </div>
            </div>

            {showAlert && (
                <div className="fixed bottom-6 right-6 z-50 animate-fade-in-up">
                    <div className="relative p-4 w-full max-w-xs rounded-lg bg-gradient-to-br from-success to-success/80 text-white shadow-xl">
                        <div className="absolute top-0 right-0 p-1">
                            <button
                                onClick={() => setShowAlert(false)}
                                className="text-white/80 hover:text-white focus:outline-none"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <div className="ml-3">
                                <h3 className="font-bold text-lg">{t('contact.alert.success')}</h3>
                                <p className="mt-1 text-sm opacity-90">{t('contact.alert.thanks')}</p>
                            </div>
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/30 overflow-hidden">
                            <div
                                className="h-full bg-white animate-progress"
                                style={{ animationDuration: '8s' }}
                                onAnimationEnd={() => setShowAlert(false)}
                            ></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Contact;